import { motion } from "framer-motion";
import { Mic, Languages, Volume2, Accessibility } from "lucide-react";

const POINTS = [
  { icon: Languages, title: "No English wall", body: "Learn entirely in Hindi, Santhali, Nagpuri or your own tongue." },
  { icon: Volume2, title: "Listen & speak", body: "Lessons you can hear, answer, and repeat — hands free while you work." },
  { icon: Accessibility, title: "Built for everyone", body: "Low-literacy friendly. If you can talk, you can learn to build with AI." },
];

export default function WhyChooseUs() {
  return (
    <section data-testid="why-choose-us" className="relative overflow-hidden bg-deep-trust-blue py-24 text-white md:py-32">
      <div className="pointer-events-none absolute -right-32 top-10 h-96 w-96 rounded-full bg-emerald-green/15 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-80 w-80 rounded-full bg-vibrant-orange/10 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:px-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-emerald-green">
            Why Unnati AI
          </span>
          <h2 className="mt-3 font-heading text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            100% Voice-First
            <span className="block text-emerald-green">Accessibility.</span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-white/70 md:text-lg">
            For millions, the English language has been the single biggest barrier to technology.
            We shatter it. Unnati AI listens and responds in the languages of rural India — so
            opportunity finally speaks everyone&apos;s mother tongue.
          </p>

          <div className="mt-8 inline-flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur">
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-xl bg-emerald-green text-deep-trust-blue">
              <Mic size={26} strokeWidth={2.5} />
            </span>
            <p className="text-sm text-white/80">
              <span className="font-heading text-lg font-bold text-white">&ldquo;Bolo, aur seekho.&rdquo;</span>
              <br /> Speak, and learn. That&apos;s the whole philosophy.
            </p>
          </div>
        </motion.div>

        <div className="grid gap-5">
          {POINTS.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="group flex items-start gap-5 rounded-2xl border border-white/10 bg-white/5 p-6 transition-colors duration-300 hover:border-emerald-green/40 hover:bg-white/10"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-vibrant-orange/15 text-vibrant-orange transition-colors group-hover:bg-vibrant-orange group-hover:text-white">
                <p.icon size={22} />
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold text-white">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/65">{p.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
